module.exports = __webpack_public_path__ + "img/Aged_Invoices_Receivable.7be423e7.jpeg";